import { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { FaultLogApi } from "@/services/FaultLog.api";
import "./style.css";

interface DevicePicListProps {
  fileNames: string[];
}

const DevicePicList = ({ fileNames }: DevicePicListProps) => {
  const [picDataUris, setPicDataUris] = useState<Record<string, string>>({});
  const [isPicLoading, setIsPicLoading] = useState(false);

  useEffect(() => {
    if (!fileNames || fileNames.length === 0) {
      setPicDataUris({});
      return;
    }

    setIsPicLoading(true);
    FaultLogApi.getDevicePicFiles(fileNames)
      .then((contents) => setPicDataUris(contents))
      .finally(() => setIsPicLoading(false));
  }, [fileNames]);

  if (!fileNames || fileNames.length === 0) {
    return null;
  }

  return (
    <Form.Group className="mb-2">
      <Form.Label>Telemetry Readings Graph</Form.Label>
      {isPicLoading ? (
        <div className="d-flex align-items-center gap-2">
          <Spinner animation="border" size="sm" />
          <span>Loading...</span>
        </div>
      ) : (
        <div className="d-flex flex-wrap gap-3">
          {fileNames.map((fileName) => (
            <div key={fileName} className="text-center">
              {picDataUris[fileName] ? (
                <a href={picDataUris[fileName]} download={fileName}>
                  <img src={picDataUris[fileName]} alt={fileName} className="device-pic-img" />
                </a>
              ) : (
                <div className="device-pic-placeholder">
                  <span className="text-muted small">{fileName}</span>
                </div>
              )}
              <div className="small text-truncate mt-1 device-pic-filename">{fileName}</div>
            </div>
          ))}
        </div>
      )}
    </Form.Group>
  );
};

export default DevicePicList;
